import { client } from '@api/client';
import { URL } from '@api/urls';

import { IOrganizationId } from '@interfaces/common/common';
import { ILinkSiteToAssetDTO } from '@interfaces/crowdcell/dto/linkSiteDTO';

const {
	assetsSites,
	assetsSiteLink,
	assetsSitesUnlink,
	unlinkSite,
	assetsRewriteSiteCoordinates,
	assetsSitesCheckCoordinates,
	assetsSitesCheckAlreadyLinked,
	assetsRewriteLinkedSitesCoordinates,
	sites,
	unlinkedSitesForLink,
} = URL;

export const unlinkSiteFromAsset = (siteDbId: string): Promise<void> => {
	return client.post(`${assetsSites}${siteDbId}${unlinkSite}`, {});
};

export const unlinkSitesFromAsset = (ids: string[]): Promise<void> => {
	return client.post(assetsSitesUnlink, { ids });
};

export const linkSiteToAsset = ({ assetDbId, siteDbId }: ILinkSiteToAssetDTO): Promise<void> => {
	return client.post(assetsSiteLink,
		{
			assetDbId,
			siteDbId,
		},
	);
};

export const rewriteSiteCoordToAsset = ({ assetDbId, siteDbId }: ILinkSiteToAssetDTO): Promise<void> => {
	return client.post(assetsRewriteSiteCoordinates,
		{
			assetDbId,
			siteDbId,
		},
	);
};

export const checkSitesCoord = ({ assetDbId, siteDbId }: ILinkSiteToAssetDTO): Promise<boolean> => {
	return client.post(assetsSitesCheckCoordinates,
		{
			assetDbId,
			siteDbId,
		},
	);
};

export const checkAlreadyLinkedSitesCoord = (ids: string[]): Promise<boolean> => {
	return client.post(assetsSitesCheckAlreadyLinked, { ids });
};

export const rewriteLinkedSitesCoord = (ids: string[]): Promise<void> => {
	return client.post(assetsRewriteLinkedSitesCoordinates, { ids });
};

export const getUnlinkedSitesForLink = (params: IOrganizationId) =>
	client.get(`${sites}${unlinkedSitesForLink}`, { params });
